(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/skeleton/assets/javascripts/helpers/handlebars-helpers.js') >= 0) return;  svs.modules.push('/components/lb-ui/skeleton/assets/javascripts/helpers/handlebars-helpers.js');

'use strict';

function registerHelpers(hbs) {
  hbs.registerHelper('skeleton', options => {
    const _options$hash = options.hash,
      height = _options$hash.height,
      numLines = _options$hash.numLines;
    const content = Array(height).fill('\u00a0').join('\n');
    const skeletonLine = "\n      <div class=\"skeleton padding-1\" data-testid=\"skeleton\">\n        ".concat(content, "\n      </div>\n    ");
    if (numLines > 1) {
      const toRender = Array(numLines);
      toRender[0] = skeletonLine;
      for (let i = 1; i < toRender.length; i++) {
        toRender[i] = "\n          <div class=\"skeleton padding-1 margin-top-1\" data-testid=\"skeleton\">\n            ".concat(content, "\n          </div>\n        ");
      }
      return new hbs.SafeString(toRender.join('\n'));
    }
    return new hbs.SafeString(skeletonLine);
  });
}
if (typeof exports === 'object') {
  registerHelpers(require('hbs'));
} else {
  registerHelpers(Handlebars);
}

 })(window);